import './style.scss';
import { ResultBody, ResultHeader } from 'views/mutual/result';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import PDFViewer from 'views/mutual/pdfViewer';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import {
  InputMaybe,
  SymbolDetailInfo,
  ApplySymbolMutation,
  ApplySymbolResult,
  OverseasRealEstateSymbolDetailInfo,
} from 'views/utils/graphql/graphql';
import { FormikProps } from 'formik';
import { ApplySymbolInput } from '../hooks';
import { useOverseasRealEstateSymbolApplyConfirm } from './hooks';
import { DateFormatType, formatDate, formatPrice } from 'views/utils/converter';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import useOnceSubmit from 'views/utils/useOnceSubmit';
import * as Yup from 'yup';
import { Caption } from 'views/mutual/caption';
import { useEffect, useState } from 'react';
import { useAuthHandler } from 'views/auth/useAuth';
import { getPdfData } from 'views/utils/download';

export type OverseasRealEstateRequestConfirmProps = {
  symbolDetail: OverseasRealEstateSymbolDetailInfo;
  interest: number | null;
  amountRaw: number | null;
  totalAmountRaw: number | null;
  applySymbolRes: Yup.Maybe<ApplySymbolResult>;
  formik: FormikProps<ApplySymbolInput>;
  backDetailPage: () => void;
};
export const OverseasRealEstateSymbolApplyConfirm = ({
  symbolDetail,
  interest,
  amountRaw,
  totalAmountRaw,
  applySymbolRes,
  formik,
  backDetailPage,
}: OverseasRealEstateRequestConfirmProps) => {
  useCustomLocationName('申込内容確認');
  const { isChecked, setIsChecked, pdfData } = useOverseasRealEstateSymbolApplyConfirm(symbolDetail, amountRaw, formik);
  const isNotErrorCode = applySymbolRes?.Code === 0;

  return (
    <>
      <div className="overseasRealEstate_requestConfirm">
        {isNotErrorCode && (
          <div className="overseasRealEstate_requestConfirm_description">
          <Description
            labelColor={labelColor.black}
            labelSize={labelSize.medium}            
            label={`ご契約内容をご確認いただくため、書類を一番下までスクロールしてください。スクロールが完了すると、ボタンが押せるようになります。`}
          />
        </div>
        )}
        <Caption label="お申込内容" />
        <div className="overseasRealEstate_requestConfirm_results">
          <ResultHeader label="案件名称" />
          <ResultBody label={symbolDetail.SymbolName} />
          <ResultHeader label="申込金額" />
          <ResultBody label={formatPrice(amountRaw) + '円'} />
          <ResultHeader label="支払日" />
          <ResultBody label={formatDate(formik.values.transferDate, DateFormatType.Japanese_yyyyMd)} />
          <ResultHeader label="経過利息" />
          <ResultBody label={formatPrice(interest) + '円'} />
          <ResultHeader label="譲渡代金総額" />
          <ResultBody label={formatPrice(totalAmountRaw) + '円'} />
          {isNotErrorCode && (
            <div className="overseasRealEstate_requestConfirm_result">
              <PDFViewer file={pdfData} isBottom={() => setIsChecked(true)} />
            </div>
          )}
        </div>

        <div className="overseasRealEstate_requestConfirm_description">
          <Description
            labelColor={labelColor.black}
            labelSize={labelSize.large}
            label={`申込人は、本事業の内容および諸リスク（税務上、法律上のリスクを含む。）について、本事業の契約締結前交付書面の記載内容に基づき説明を受け、その内容を十分理解した上で自己の責任において本事業への出資を決定しましたので、以下の出資を申込みます。なお、申込人の本出資にかかる情報は、出資契約の締結および本事業の遂行のため、組合契約地位譲渡人である株式会社ＦＰＧ証券に提供され、本事業が継続する間、株式会社ＦＰＧとの間で相互に共有されることに同意します。`}
          />
          {!isNotErrorCode && (
            <div className="overseasRealEstate_requestConfirm_description_subDescription">
              <div>本申込みは最終的な契約締結の申し込みではありません。</div>
              <div>契約時間外または残高確認中の場合は、申し込みのみ受け付けます。</div>
              <div>弊社による審査の結果、ご投資いただけるお客様には別途ご契約手続きをご案内いたします。</div>
            </div>
          )}
        </div>
        <div className="overseasRealEstate_requestConfirm_buttons">
          <Button
            label={!isNotErrorCode ? '出資を申込む' : '契約締結を申込む'}
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
            disable={!isNotErrorCode ? false : !isChecked}
            onClick={formik.handleSubmit}
          />
          <Button
            label="案件詳細画面へ戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={backDetailPage}
          />
        </div>
      </div>
    </>
  );
};
